var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 12v-.5C42 8.468 39.533 6 36.5 6h-25C8.467 6 6 8.468 6 11.5V12H42zM6 15v21.5c0 3.038 2.462 5.5 5.5 5.5h25c3.038 0 5.5-2.462 5.5-5.5V15H6zM14.5 37c-1.381 0-2.5-1.119-2.5-2.5 0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5C17 35.881 15.881 37 14.5 37zM14.5 30c-1.381 0-2.5-1.119-2.5-2.5 0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5C17 28.881 15.881 30 14.5 30zM34.5 36h-13c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5h13c.828 0 1.5.672 1.5 1.5S35.328 36 34.5 36zM34.5 29h-13c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5h13c.828 0 1.5.672 1.5 1.5S35.328 29 34.5 29zM34.5 22h-21c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5h21c.828 0 1.5.672 1.5 1.5S35.328 22 34.5 22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverage);
export default __webpack_public_path__ + "static/media/coverage.ab835cee8d501e59978fa84b512ece41.svg";
export { ForwardRef as ReactComponent };